import React, { useState } from "react";
import { Button, Modal } from "antd";

import CustomButton from "../CustomButton";
import phone from "../../assest/preview pic.png";
import template from "../../assest/template.png";

import TemplateDesignes from "./TemplateDesignes";

const CampaignMessagepreview2 = ({ visible, onClose, selectedtemplate ,setSelecteddomain,setSelectedloginTempalte,Selecteddomain,SelectedloginTempalte}) => {
  const cancel = () => {
    onClose();
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  return (
    <>
      <Modal open={visible} onCancel={onClose} centered footer={[]}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
            marginTop: "40px",
          }}
        >
          <div>
            <h1 >Message Preview</h1>
            <p>Lorem ipsum dolor sit amet consectetur. Proin sit donec.</p>
          </div>
          <Button
            type="primary"
            shape="round"
            onClick={() => {
              setIsModalVisible(true);
            }}
          >
            Insert Phishing Link
          </Button>
        </div>

        {(SelectedloginTempalte !== null || Selecteddomain !== null) && (
<div className="flex gap-3 items-center bg-gray-100 rounded-md p-2">
  <img src={template} alt="tem" className="w-16 h-16 rounded-lg"/>
  <div className="space-y-2 w-full">
    <h5 className="font-medium text-[#3A3B3F] text-lg"> {SelectedloginTempalte?.name}</h5>
    <p className="bg-[#ECFDF5] rounded-md px-2 w-fit text-xs text-[#16A34A]"> &bull; {Selecteddomain?.url}</p>
  </div>
</div>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ position: "relative" }}>
            <img className="w-96" alt="" src={phone} />
            <p className="insideshowmessage  max-h-96 overflow-auto">{selectedtemplate?.message}
              <br />
            <span className="text-blue-500 underline underline-offset-2">{Selecteddomain?.url}</span>
            </p>
          </div>
        </div>

        <CustomButton
          style={{ margin: "auto", display: "flex" }}
          width={"50%"}
          onClick={cancel}
          text={"Continue"}
        />
      </Modal>
      <TemplateDesignes
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onSave={() => setIsModalVisible(false)}
        setSelecteddomain={setSelecteddomain}
        setSelectedloginTempalte={setSelectedloginTempalte}
      />
    </>
  );
};

export default CampaignMessagepreview2;
